import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import FeedbackActions from '../feedback/FeedbackActions';
import RippleAvatar from '../loaders/RippleAvatar';
import ResourcesCarousel from '../resources/ResourcesCarousel';
import type { ChatResourceItem } from '../resources/ResourceCard';
import useChatResourceActions from '../../hooks/useChatResourceActions';
import { useChatContext } from '../../context/ChatProvider';
import type { ChatMessage } from '../../lib/types';
import './chatbotResponse.scss';

interface ChatbotResponseProps {
  message: ChatMessage;
  showFeedbackActions?: boolean;
}

const ChatbotResponse = ({
  message,
  showFeedbackActions = false,
}: ChatbotResponseProps) => {
  const { caremapprAppUserId, chatStartedWithConsultId } = useChatContext();
  const { openResourceUrl, addResourceToPatientPortal } =
    useChatResourceActions({ caremapprAppUserId });
  const rawResources = message.data?.endoPatientResources;
  const resources = Array.isArray(rawResources)
    ? (rawResources as ChatResourceItem[]).filter(
        (item) =>
          Boolean(item) &&
          typeof item.entryId === 'string' &&
          typeof item.title === 'string' &&
          typeof item.description === 'string',
      )
    : [];

  return (
    <div className="chat-main__assistant">
      <div className="chat-main__assistant-header">
        <RippleAvatar />
        <span className="chat-main__assistant-name">
          {message.data?.authorName || 'EndoZoneAI'}
        </span>
      </div>
      <div className="chat-main__assistant-body">
        <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
          {message.text}
        </ReactMarkdown>
      </div>
      <ResourcesCarousel
        items={resources}
        onVisitSource={openResourceUrl}
        onAddToPatient={addResourceToPatientPortal}
        showAddToPatient={chatStartedWithConsultId}
      />
      <div className="chat-main__assistant-footer">
        <div className="chat-main__message-time">{message.createdAt}</div>
        {showFeedbackActions ? (
          <FeedbackActions messageId={message.id} messageText={message.text} />
        ) : null}
      </div>
    </div>
  );
};

export default ChatbotResponse;
